import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { Form, Field } from 'react-final-form';
import { clearSearch, searchGroups } from 'actions/search';
import { Spinner } from 'UI';
import { Search } from 'UI/Inputs';
import { Button, Radio } from '@haldor/ui';

var SearchGroups = function SearchGroups(props) {
  var translate = useTranslate();
  var dispatch = useDispatch();
  var searchResults = useSelector(function (state) {
    return state.Search.groups;
  });

  var onSearch = function onSearch(values) {
    if (values.query == '') {
      dispatch(clearSearch());
      return true;
    }

    if (values.query.length < 3) {
      return false;
    }

    dispatch(searchGroups({
      filter: 'EDUCATION_GROUP;',
      query: values.query
    }));
  };

  var onSubmit = function onSubmit(values) {
    return new Promise(function (resolve) {
      if (props.onSubmit != null) {
        props.onSubmit(values).then(function () {
          resolve(1);
        });
        dispatch(clearSearch());
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form select-user-form"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    mutators: {
      clearUserId: function clearUserId(args, state, utils) {
        utils.changeValue(state, 'group', function () {
          return '';
        });
      }
    },
    render: function render(_ref) {
      var _form$getFieldState;

      var handleSubmit = _ref.handleSubmit,
          form = _ref.form,
          submitting = _ref.submitting,
          valid = _ref.valid;
      var group = (_form$getFieldState = form.getFieldState('group')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "form-component"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '0.35rem'
        }
      }, /*#__PURE__*/React.createElement(Search, {
        onSubmit: function onSubmit(values) {
          form.mutators.clearUserId();
          onSearch(values);
        },
        placeholder: translate('Search group'),
        allowEmpty: true,
        clearOnSubmit: true
      })), (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row user-list"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#f2f3f2',
          padding: '1rem'
        }
      }, searchResults.map(function (group) {
        return /*#__PURE__*/React.createElement("div", {
          className: "user",
          key: group.id
        }, /*#__PURE__*/React.createElement(Field, {
          component: Radio,
          name: "group",
          label: group.title,
          optionValue: group
        }));
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '.5rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || group == null || group == ''
      }, submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null, translate('Add'))));
    }
  }));
};

export default SearchGroups;